// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-nav-link {\n  color: var(--sidebar-text-color);\n  font-weight: 700;\n  text-transform: uppercase;\n  text-decoration-line: none;\n  cursor: pointer;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  border-bottom: 1px solid transparent;\n}\n.menu-nav-link:hover {\n  border-bottom: 1px solid var(--sidebar-text-color);\n}\n", ""]);
// Exports
module.exports = exports;
